import React from 'react';
import { useQuery } from 'react-query';
import { getUserAddresses } from '../../../MyApi/user';
import AddressCard from './addressCard';

const Addresses = ({ id }) => {
  const { data, isLoading, error } = useQuery(
    ['userAddresses', id],
    () => getUserAddresses(id),
    {
      enabled: !!id,
    }
  );

  if (isLoading) return <div className='skeleton'></div>;
  if (error) return <div>Error loading addresses</div>;

  const addresses = data?.data?.addresses || [];

  return (
    <div className="addresses-container">
      <h5 className="mb-3">العناوين</h5>
      {addresses.length === 0 ? (
        <p>لا يوجد عناوين متاحة</p>
      ) : (
        <div className="addresses-grid">
          {addresses.map((address) => (
            <AddressCard key={address.id} address={address} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Addresses;
